import { render, staticRenderFns } from "./UpdateRecord.vue?vue&type=template&id=aaaab0d4&scoped=true"
import script from "./UpdateRecord.vue?vue&type=script&lang=js"
export * from "./UpdateRecord.vue?vue&type=script&lang=js"
import style0 from "./UpdateRecord.vue?vue&type=style&index=0&id=aaaab0d4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaab0d4",
  null
  
)

export default component.exports